'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = requestMiddleware;

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _requests = require('../actions/requests');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRequest(url, _ref) {
    var _ref$method = _ref.method,
        method = _ref$method === undefined ? 'get' : _ref$method,
        _ref$headers = _ref.headers,
        headers = _ref$headers === undefined ? {} : _ref$headers,
        _ref$query = _ref.query,
        query = _ref$query === undefined ? {} : _ref$query,
        _ref$data = _ref.data,
        data = _ref$data === undefined ? null : _ref$data,
        _ref$asForm = _ref.asForm,
        asForm = _ref$asForm === undefined ? false : _ref$asForm;

    // if (url.indexOf('//') === 0) {
    //     url = window.location.protocol + url;
    // }

    var req = (0, _superagent2.default)(method.toUpperCase(), url);
    for (var headerName in headers) {
        req = req.set(headerName, headers[headerName]);
    }

    if (Object.keys(query).length) {
        req = req.query(query);
    }

    if (asForm) req.type('form');

    if (data) req = req.send(data);
    return req;
}

var requestStack = {};

function requestMiddleware(_ref2) {
    var getState = _ref2.getState;

    return function (next) {
        return function (action) {
            if (action && action.type !== _requests.REQUEST_ACTION) return next(action);

            var actionData = action.payload;

            // Abort previos
            if (actionData.options.stack && requestStack[actionData.options.stack]) {
                requestStack[actionData.options.stack].abort();
                requestStack[actionData.options.stack] = null;
            }

            // Start Action
            var actionName = actionData.action;
            next({ type: actionName, payload: actionData });

            var state = getState();
            var _state$user = state.user,
                token = _state$user.token,
                tokenType = _state$user.tokenType,
                auth = state.config.auth;

            var validToken = void 0;
            if (auth && auth.isImplicit) {
                if (typeof auth.OAUTHToken === 'boolean' && auth.OAUTHToken === false) {
                    validToken = null;
                } else if ('OAUTHToken' in auth) {
                    validToken = auth.OAUTHToken;
                } else if (Object.keys(auth).length) {
                    validToken = tokenType + ' ' + token;
                }
            }

            if (validToken) {
                actionData.options = _extends({}, actionData.options, {
                    headers: _extends({}, actionData.options.headers, {
                        Authorization: validToken
                    })
                });
            }

            var req = createRequest(actionData.url, actionData.options);

            // Save to stack
            if (actionData.options.stack) {
                requestStack[actionData.options.stack] = req;
            }

            var SUCCESS_ACTION = actionData.options.actionSuccess || actionName + '_SUCCESS';
            var FAIL_ACTION = actionData.options.actionFail || actionName + '_FAIL';

            // CallApi
            req.end(function (err, res) {
                if (err || !res.ok) {
                    if (auth && auth.isImplicit && res && res.statusCode === 403) {
                        var user = state.user;

                        if (user && 'auth_url' in user) {
                            window.location = user.auth_url;
                        } else if ('PrimaryAuthUrl' in auth) {
                            window.location = auth.PrimaryAuthUrl;
                        } else {
                            var OAUTHClientId = auth.OAUTHClientId,
                                OAUTHUrl = auth.OAUTHUrl,
                                OAUTHRedirectUrl = auth.OAUTHRedirectUrl;

                            var url = OAUTHUrl + '/auth/authorize?response_type=token&client_id=' + OAUTHClientId + '&state=xyz&scope=all&redirect_uri=' + OAUTHRedirectUrl;
                            window.location = url;
                        }
                    }

                    if (actionData.options.fail) actionData.options.fail(res, next);
                    next({ type: FAIL_ACTION, payload: res, options: actionData.options });
                } else {
                    if (actionData.options.success) actionData.options.success(res, next);
                    next({ type: SUCCESS_ACTION, payload: res, options: actionData.options });
                }
            });
        };
    };
}
//# sourceMappingURL=RequestMiddleware.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/middlewares/RequestMiddleware.js
// module id = 1282
// module chunks = 5